// extracted by mini-css-extract-plugin
export var bacgroundImage = "HeaderSection-module--bacgroundImage--e59a1";
export var backdrop = "HeaderSection-module--backdrop--47b14";
export var backdropOpen = "HeaderSection-module--backdropOpen--ac59b";
export var categoryLinks = "HeaderSection-module--categoryLinks--1e425";
export var fontSizeFix = "HeaderSection-module--fontSizeFix--fabc0";
export var gridIamge = "HeaderSection-module--gridIamge--56775";
export var gridposition = "HeaderSection-module--gridposition--5b2a4";
export var habmurgerLabel = "HeaderSection-module--habmurgerLabel--74acf";
export var hamburgerButton = "HeaderSection-module--hamburgerButton--3a152";
export var headerContainer = "HeaderSection-module--headerContainer--fa5b4";
export var headerContentContainter = "HeaderSection-module--headerContentContainter--3c980";
export var itemsAligment = "HeaderSection-module--itemsAligment--171a8";
export var languageSelectiorScrolled = "HeaderSection-module--languageSelectiorScrolled--d9728";
export var locationMap = "HeaderSection-module--locationMap--bc023";
export var mapIcon = "HeaderSection-module--mapIcon--d7287";
export var mobileContainer = "HeaderSection-module--mobileContainer--eadbc";
export var mobileContentContainer = "HeaderSection-module--mobileContentContainer--9db08";
export var mobileMenu = "HeaderSection-module--mobileMenu--3f123";
export var mobileMenuFooter = "HeaderSection-module--mobileMenuFooter--87c82";
export var mobileMenuFooterContent = "HeaderSection-module--mobileMenuFooterContent--4a399";
export var mobileMenuHeader = "HeaderSection-module--mobileMenuHeader--b125f";
export var mobileMenuOpen = "HeaderSection-module--mobileMenuOpen--687f7";
export var mobileOpenedLogoContainer = "HeaderSection-module--mobileOpenedLogoContainer--112ad";
export var navContentContainer = "HeaderSection-module--navContentContainer--09dd6";
export var navStyling = "HeaderSection-module--navStyling--a0b7e";
export var openedContainer = "HeaderSection-module--openedContainer--3058e";
export var openedLogoContainer = "HeaderSection-module--openedLogoContainer--ee605";
export var scrolledContainer = "HeaderSection-module--scrolledContainer--34a50";
export var scrolledHeaderContentContainer = "HeaderSection-module--scrolledHeaderContentContainer--6f490";
export var scrolledLogoContainer = "HeaderSection-module--scrolledLogoContainer--cd574";
export var scrolledNavContentContainer = "HeaderSection-module--scrolledNavContentContainer--22359";
export var socialIcon = "HeaderSection-module--socialIcon--9f42b";
export var socialIconsStyling = "HeaderSection-module--socialIconsStyling--99f9e";